// extracted by mini-css-extract-plugin
export default {"cls1":"PasswordFieldSet-Fieldset_cls1__C8PF6","cls2":"PasswordFieldSet-Fieldset_cls2__KOgtf PasswordFieldSet-Fieldset_cls1__C8PF6"};